import React, { useCallback, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Loader, useModal } from '@jutro/components';
import { withIntl } from '@jutro/locale';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
// import {policyDocumentTable} from '../../util/DocumentUtil';
import { BillingService } from "gw-capability-billing";
import metadata from './CPMIDocumentsComponent.metadata.json5';
import messages from './DocumentsComponent.messages';
import styles from './CPMIDocumentsComponent.module.scss';
import { LoaderExt } from 'gw-components-platform-react';
import { PolicyService } from 'gw-capability-gateway';

import moment from 'moment';
import { DocumentService } from 'gw-capability-policydocument';
import { GatewayDocumentService } from 'gw-capability-gateway-document';

import { Link } from '@jutro/router';

const getDateModified = (items, index, { path: property }) => {
    return <span>{items[property]}</span>;
};

const CPMIDocumentsComponent = (props) => {
    const {
        showConfirm
    } = useModal();

    const {
        authHeader,
        initialDocumentsData,
        showDocumentUpload,
        uploadDocument,
        deleteDocument,
        downloadDocument,
        noDataMessage,
        showPagination,
        showHeader,
        showSearch,
        isLoading,
        value,
        intl,
        policyDetailsData,
        history
    } = props;
  
    const { UserService } = useDependencies('UserService');
    const [showDocumentUploadButton, updateShowDocumentUploadButton] = useState(false);
    const [searchKeyword, setKeyword] = useState('');
    const [actTab, setActTab] = useState();
    const termNumber = policyDetailsData.policyResponse.latestPeriod.termNumber;
    const expirationDate = policyDetailsData.policyResponse.latestPeriod.expirationDate;
    // const jobNumber = policyDetailsData.policyResponse.policyNumber;
    const policyNumber = policyDetailsData.policyResponse.policyNumber;
    const effectiveDate = policyDetailsData.policyResponse.latestPeriod.effectiveDate;
    let jobNumberPolicyNumberObj;
    const [selectedValueDropdown, setSelectedValueDropdown] = useState();
    const [policyTermsArray, setPolicyTermsArray] = useState([]);
    const [defaultPolicyTermsForPolicySecure_Ext, setDefaultPolicyTermsForPolicySecure_Ext] = useState([]);
    const [responseSearchPolicy, setResponseSearchPolicy] = useState([]);
    let policyTable = [];
    let selectedValueDropdown1;
    let selectedDropdownPolicyNumber;
    const [policyDataSet, setPolicyDataSet] = useState([]);
    const [billingDataSet, setBillingDataSet] = useState([]);
    const [claimsDataSet, setClaimsDataSet] = useState([]);
    const [otherDataSet, setOtherDataSet] = useState([]);

    useEffect(() => {
        if (showHeader) {
            const permissionDTO = {
                permission: 'doccreate'
            };
            UserService.hasUserSystemPermission(permissionDTO, authHeader)
                .then((isUserPermission) => {
                    updateShowDocumentUploadButton(isUserPermission);
                });
        }
        // Disabling to prevent continues re-rendering
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const accountNumber = policyDetailsData.policyResponse.account.accountNumber;
        jobNumberPolicyNumberObj = PolicyService.getPolicyTermsForPolicySecure_Ext(policyNumber, accountNumber, authHeader)
            .then((jobNumberPolicyNumberObj1) => {
                for (let i = 0; i < jobNumberPolicyNumberObj1.length; i++) {
                    if (!jobNumberPolicyNumberObj1[i].hasOwnProperty('termNumber')) {
                        console.log('No term number found for this account, adding a term Number of 1');
                        jobNumberPolicyNumberObj1[i].termNumber = 1;
                    }
                }
                setDefaultPolicyTermsForPolicySecure_Ext(jobNumberPolicyNumberObj1);
            })
    }, [jobNumberPolicyNumberObj])


    useEffect(() => {
        const arrayTerm = [];

        defaultPolicyTermsForPolicySecure_Ext.map((item) => {
            arrayTerm.push({ name: `${moment(item.effectiveDate).format('MM/DD/YYYY')} - ${moment(item.expirationDate).format('MM/DD/YYYY')}`, code: item.termNumber });
        })

        setSelectedValueDropdown(arrayTerm[0]?.code)
        setPolicyTermsArray(arrayTerm)

        if (arrayTerm && arrayTerm.length > 0) {
            BillingService.getDocumentsForPolicyBySearch(policyNumber, parseInt(arrayTerm[0].code), authHeader)
                .then((billingResponse) => {
                    billingResponse.sort((a, b) => {
                        const createSortKey = (p) => { return `${p.dateModified}` }
                        return createSortKey(a) > createSortKey(b) ? -1 : 1
                    })
                    billingResponse.map((itm) => {
                        itm.dateModified = `${moment(itm.dateModified).format('MM/DD/YYYY')}`
                    })

                    setBillingDataSet(billingResponse);
                })
            PolicyService.getPolicyLossRunDocuments(policyNumber, authHeader)
                .then((CalimsResponse) => {
                    CalimsResponse.sort((a, b) => {
                        const createSortKey = (p) => { return `${p.dateModified}` }
                        return createSortKey(a) > createSortKey(b) ? -1 : 1
                    })
                    CalimsResponse.map((itm) => {
                        itm.dateModified = `${moment(itm.dateModified).format('MM/DD/YYYY')}`
                    })
                    setClaimsDataSet(CalimsResponse);
                })
            PolicyService.getDocumentsForPolicyByType(policyNumber, authHeader)
                .then((otherresponse) => {
                    otherresponse.sort((a, b) => {
                        const createSortKey = (p) => { return `${p.dateModified}` }
                        return createSortKey(a) > createSortKey(b) ? -1 : 1
                    })
                    otherresponse.map((itm) => {
                        itm.dateModified = `${moment(itm.dateModified).format('MM/DD/YYYY')}`
                    })
                    setClaimsDataSet(otherresponse);
                })
        }

        defaultPolicyTermsForPolicySecure_Ext.map((subItem) => {
            if (subItem.termNumber === parseInt(arrayTerm[0].code)) {
                PolicyService.getDocumentsForPolicyBySearchSecure_Ext(subItem, authHeader)
                    .then((responseObjectSearch) => {
                        responseObjectSearch.sort((a, b) => {
                            const createSortKey = (p) => { return `${p.dateModified}` }
                            return createSortKey(a) > createSortKey(b) ? -1 : 1
                        })
                        responseObjectSearch.map((itm) => {
                            itm.dateModified = `${moment(itm.dateModified).format('MM/DD/YYYY')}`
                        })
                        setResponseSearchPolicy(responseObjectSearch);
                        setPolicyDataSet(responseObjectSearch);
                    })

            }
        })

    }, [defaultPolicyTermsForPolicySecure_Ext])

    // const getDownloadLink = useCallback(
    //     (item) => {
    //         const { publicID, sessionID } = item;
    //         return downloadDocument(publicID, sessionID);
    //         // return DocumentService.downloadPolicyDocument(publicID, sessionID);
    //         // return GatewayDocumentService.downloadDocument(authHeader).then((res)=>{setUploadTokenID(res)})
    //     },
    //     [downloadDocument]
    // );

    const getDownloadLink = useCallback(
        (item) => {
            const { docUID, sessionID } = item;
            return GatewayDocumentService.downloadDocument(docUID, sessionID);
        },
        []
    );

    const getBillingDownloadLink = useCallback(
        (item) => {
            const { publicID, sessionID } = item;

            return BillingService.downloadbillingDocument(publicID, sessionID);
        },
        []
    );

    const onDeleteDocumentIcon = useCallback(
        (e, item) => {
            e.preventDefault();
            const { publicID } = item;
            showConfirm({
                title: messages.removeDocument,
                message: messages.confirmRemoveDocument,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.documentRemoveConfirmYes,
                cancelButtonText: messages.documentRemoveConfirmNo
            }).then(async (results) => {
                if (results === 'cancel' || results === 'close') {
                    return _.noop();
                }
                deleteDocument(publicID);
                return true;
            }, _.noop);
        },
        [deleteDocument, showConfirm]
    );

    const getRemoveIcon = useCallback(
        (item, index, property) => {
            return (
                <Link
                    href={item[property.id]}
                    onClick={(e) => onDeleteDocumentIcon(e, item)}
                    className={styles.trashLink}
                    icon="mi-delete"
                />
            );
        },
        [onDeleteDocumentIcon]
    );

    const getNameLink = useCallback(
        (item, index, { path: property }) => {
            const downloadLink = getDownloadLink(item);
            return (
                <div style={{ textAlign: 'left' }}>
                    <Link
                        icon="mi-insert_drive_file"
                        href={downloadLink}
                        target="_blank"
                    >
                        {item[property]}
                    </Link>
                </div>
            );
        },
        [getDownloadLink]
    );

    const getBillingDocuments = useCallback(
        (item, index, { path: property }) => {
            const downloadLink = getBillingDownloadLink(item);
            return (
                <div style={{ textAlign: 'left' }}>
                    <Link
                        icon="mi-insert_drive_file"
                        href={downloadLink}
                        target="_blank"
                    >
                        {item[property]}
                    </Link>
                </div>
            );
        },
        [getBillingDownloadLink]
    );



    const handleSearchValueChange = useCallback((keyword) => {
        setKeyword(keyword);
    }, []);


    const policySearchButtonClick = useCallback(() => {
        // BillingService.getDocumentsForPolicyBySearch(selectedDropdownPolicyNumber,parseInt(selectedValueDropdown1),authHeader);
        // PolicyService.getPolicyLossRunDocuments(selectedDropdownPolicyNumber,authHeader);
        // PolicyService.getDocumentsForPolicyByType(selectedDropdownPolicyNumber,authHeader);
        defaultPolicyTermsForPolicySecure_Ext.map((subItem) => {
            if (subItem.termNumber === parseInt(selectedValueDropdown1.code)) {
                PolicyService.getDocumentsForPolicyBySearchSecure_Ext(subItem, authHeader)
                    .then((responseObjectSearch) => {
                        responseObjectSearch.sort((a, b) => {
                            const createSortKey = (p) => { return `${p.dateModified}` }
                            return createSortKey(a) > createSortKey(b) ? 1 : -1
                        })
                        responseObjectSearch.map((itm) => {
                            itm.dateModified = `${moment(itm.dateModified).format('MM/DD/YYYY')}`
                        })
                        setResponseSearchPolicy(responseObjectSearch);
                        // console.log(responseObjectSearch,"responseObjectSearch")
                    })

            }
        })


    }, [defaultPolicyTermsForPolicySecure_Ext]);

    // const policyTabClick = useCallback((value)=>{
    //     if(value === "policyTab"){
    //         setResponseSearchPolicy(policyDataSet);
    //     }else if(value === "billingTab"){
    //         setResponseSearchPolicy(billingDataSet);
    //     }else if(value === "claimsTab"){
    //         setResponseSearchPolicy(claimsDataSet);
    //     }else {
    //         setResponseSearchPolicy(otherDataSet);
    //     }
    // },[value])

    const policyTermValueChange = useCallback((value) => {
        setSelectedValueDropdown(value);
        selectedValueDropdown1 = '';
        selectedValueDropdown1 = value;
        defaultPolicyTermsForPolicySecure_Ext.map((subItem) => {
            if (subItem.termNumber === parseInt(value)) {
                selectedDropdownPolicyNumber = '';
                selectedDropdownPolicyNumber = subItem.policyNumber;
                PolicyService.getDocumentsForPolicyBySearchSecure_Ext(subItem, authHeader)
                    .then((responseObjectSearch) => {
                        responseObjectSearch.sort((a, b) => {
                            const createSortKey = (p) => { return `${p.dateModified}` }
                            return createSortKey(a) > createSortKey(b) ? 1 : -1
                        })
                        responseObjectSearch.map((itm) => {
                            itm.dateModified = `${moment(itm.dateModified).format('MM/DD/YYYY')}`
                        })
                        setResponseSearchPolicy(responseObjectSearch);
                        // console.log(responseObjectSearch,"responseObjectSearch")
                    })
            }
        })


        // responseSearchPolicy && responseSearchPolicy.map((responsePolicyItm)=>{
        //     return setPolicyObj({
        //         dateModified:responsePolicyItm.dateModified,
        //         description:responsePolicyItm.description,
        //         documentType:responsePolicyItm.documentType
        //     })

        // })

    }, [defaultPolicyTermsForPolicySecure_Ext]);



    const getFormattedDate = ((item, index, property) => {
        return moment(item[property.id]).format('MM/DD/YYYY');
    });

    const getData = (value) => {
        const tableData = responseSearchPolicy;
        let res = tableData;
        if (value?.sorted[0]?.id === "tablePolicyDetailsCreatedDate" || value?.sorted[0]?.id === "dateModified") {
            res = tableData.sort((a, b) => {
                a = a.dateModified;
                b = b.dateModified;
                if (value?.sorted[0]?.desc) {
                    return new Date(b) - new Date(a);
                }
                return new Date(a) - new Date(b);
            })
        }
        if (value?.sorted[0]?.id === "tableDescription" || value?.sorted[0]?.id === "description") {
            res = tableData.sort((a1, b1) => {
                if (value?.sorted[0]?.desc) {
                    return b1.description.localeCompare(a1.description)
                }
                return a1.description.localeCompare(b1.description)
            })
        }
        if (value?.sorted[0]?.id === "tableDocumentType" || value?.sorted[0]?.id === "documentType") {
            res = tableData.sort((a1, b1) => {
                if (value?.sorted[0]?.desc) {
                    return b1.documentType.localeCompare(a1.documentType)
                }
                return a1.documentType.localeCompare(b1.documentType)
            })
        }

        const temp = {
            rows: res,
            numberOfRows: res.length
        }
        return temp
    }

    const billingScreen = useCallback((e) => {
        
        
        if (e === "billingTab") {
            //return <Link to={`/accounts/${policyDetailsData.policyResponse.account.accountNumber}/summary`} />
            return history.push({

                pathname: `/accounts/${policyDetailsData.policyResponse.account.accountNumber}/billingAndPayment`,
    
                state: {
    
                    documentTab:true
    
                },
            });
            // return history.push(`/accounts/${policyDetailsData.policyResponse.account.accountNumber}/billingAndPayment`);
            //return <Redirect to={`/accounts/${policyDetailsData.policyResponse.account.accountNumber}/summary`}/>;
        } 
        
        setActTab(e)
    

    }, [history, policyDetailsData.policyResponse.account.accountNumber])

    const overrideProps = {
        documentTableGrid: {
            data: [],//formatDocumentTableData(intl, initialDocumentsData || value, searchKeyword),
            visible: !_.isEmpty(initialDocumentsData || value) && !isLoading,
            showPagination,
            showSearch
        },
        tilesPageHeaderSpan: {
            visible: (showDocumentUploadButton || showDocumentUpload)
        },
        noDocumentsDetails: {
            visible: !!noDataMessage && _.isEmpty(initialDocumentsData || value) && !isLoading
        },
        noDocumentsText: {
            message: noDataMessage
        },
        documentsTitleId: {
            visible: showHeader
        },
        uploadDocuments: {
            visible: !showHeader && showDocumentUpload
        },
        searchFilter: {
            visible: !_.isEmpty(initialDocumentsData || value),
            value: searchKeyword
        },
        allPolicyTerms: {
            availableValues: policyTermsArray,
            value: selectedValueDropdown,
            //defaultValue: policyTermsArray[0],
        },
        tablePolicyDetails: {
            data: responseSearchPolicy,//policyDocumentTable(intl, responseSearchPolicy || value, searchKeyword),
            visible: !_.isEmpty(responseSearchPolicy) && !isLoading,
            showPagination,
            showSearch,
            onFetchData: getData
        },
        tableBillingDetails: {
            data: billingDataSet,//policyDocumentTable(intl, responseSearchPolicy || value, searchKeyword),
            visible: !_.isEmpty(billingDataSet) && !isLoading, //!_.isEmpty(responseSearchPolicy) && !isLoading,
            showPagination,
            showSearch
        },
        stpDetailsTabset: {
            onTabChange: billingScreen,
            activeTab: actTab
        }

    };

    // policyTable =renderPolicyTable()

    // const renderPolicyTable =()=>{
    //    return responseSearchPolicy && responseSearchPolicy.map((item)=>{
    //         return {
    //             dateModified: item.dateModified,
    //             description: item.description,
    //             documentType: item.documentType
    //         }
    //     }) 

    // }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getNameLink: getNameLink,
            getBillingDocuments: getBillingDocuments,
            // getDateModified: getDateModified,
            // getRemoveIcon: getRemoveIcon,
            // onUploadDocument: uploadDocument,
            // handleSearchValueChange: handleSearchValueChange,
            policyTermValueChange: policyTermValueChange,
            policySearchButtonClick: policySearchButtonClick,
            getFormattedDate: getFormattedDate,
            billingScreen: billingScreen
            // billingTabClick: billingTabClick,
            // claimsTabClick: claimsTabClick,
            // otherTabClick: otherTabClick
        }
    };

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }

    return (

        <Loader loaded={!isLoading}>
            <ViewModelForm
                uiProps={metadata.componentContent}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </Loader>
    );
};

CPMIDocumentsComponent.propTypes = {
    authHeader: PropTypes.shape({
        Authorization: PropTypes.string
    }).isRequired,
    initialDocumentsData: PropTypes.shape({}),
    value: PropTypes.shape({}),
    uploadDocument: PropTypes.func.isRequired,
    deleteDocument: PropTypes.func.isRequired,
    downloadDocument: PropTypes.func.isRequired,
    noDataMessage: PropTypes.string,
    showPagination: PropTypes.bool,
    showHeader: PropTypes.bool,
    showSearch: PropTypes.bool,
    showDocumentUpload: PropTypes.bool,
    isLoading: PropTypes.bool,
    intl: PropTypes.func.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
};

CPMIDocumentsComponent.defaultProps = {
    showPagination: true,
    noDataMessage: '',
    showHeader: true,
    showSearch: false,
    showDocumentUpload: false,
    isLoading: false,
    value: undefined,
    initialDocumentsData: undefined
};

export default withIntl(withAuthenticationContext(withRouter(CPMIDocumentsComponent)));
